import "react-bootstrap-typeahead/css/Typeahead.css";

import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";

import { useTagsDocument } from "../../api/firestoreWrappers.generated";

function CorvusTagger(props) {
    const ref = React.createRef();
    const [allTags] = useTagsDocument({ mode: "once" });
    const typedTags = allTags?.[props.name] || [];

    return (
        <Typeahead
            id="tag-selector"
            ref={ref}
            labelKey="name"
            multiple={true}
            options={typedTags}
            placeholder={`Tag this ${props.name} ...`}
            allowNew={true}
            caseSensitive={false}
            newSelectionPrefix="Add a new tag: "
            selected={props.selected || []}
            onChange={props.onChange}
        />
    );
}

export function MeasurementTagger(props) {
    return (
        <CorvusTagger
            name="measurement"
            className={props.className}
            selected={props.selected}
            onChange={props.onChange}
        />
    );
}

export function FlightTagger(props) {
    return (
        <CorvusTagger
            name="flight"
            className={props.className}
            selected={props.selected}
            onChange={props.onChange}
        />
    );
}
